import { useEffect, useState } from 'react'
import { useNavigate, Outlet } from 'react-router-dom'
import type { AuthUser } from '@/lib/hooks/useAuth'
import { Sidebar } from '@/components/dashboard/Sidebar'
import { ProviderSidebar } from '@/components/dashboard/ProviderSidebar'
import { CentreFormationSidebar } from '@/components/dashboard/CentreFormationSidebar'
import { CatalogueContext } from '@/lib/catalogue-context'

export default function CatalogueLayout() {
  const [user, setUser] = useState<AuthUser | null>(null)
  const [ready, setReady] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const token = localStorage.getItem('velink_token')
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        if (payload.exp * 1000 > Date.now()) {
          setUser(payload as AuthUser)
        }
      } catch { /* token invalide */ }
    }
    setReady(true)
  }, [])

  function handleLogout() {
    localStorage.removeItem('velink_token')
    navigate('/connexion')
  }

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #0A0A14 0%, #0D0D2B 50%, #0A0A14 100%)' }}>
        <div className="w-8 h-8 border-2 border-accent/30 border-t-accent rounded-full animate-spin" />
      </div>
    )
  }

  if (!user) {
    return (
      <CatalogueContext.Provider value={{ hasNav: false }}>
        <Outlet />
      </CatalogueContext.Provider>
    )
  }

  return (
    <CatalogueContext.Provider value={{ hasNav: true }}>
      <div className="flex min-h-screen" style={{ background: 'linear-gradient(135deg, #0A0A14 0%, #0D0D2B 50%, #0A0A14 100%)' }}>
        {user.role === 'PROVIDER' && (
          <ProviderSidebar user={user} onLogout={handleLogout} />
        )}
        {user.role === 'COMPANY' && user.companyType !== 'TRAINING_CENTER' && (
          <Sidebar user={user} onLogout={handleLogout} />
        )}
        {user.role === 'COMPANY' && user.companyType === 'TRAINING_CENTER' && (
          <CentreFormationSidebar user={user} onLogout={handleLogout} />
        )}
        <div className="ml-60 flex-1 min-h-screen">
          <Outlet />
        </div>
      </div>
    </CatalogueContext.Provider>
  )
}
